/*
 * KPIsOverviewCatalogue.js
 * ---------------------------------------------------------------------------
 * Catalogo de tecnologias, niveis de agregacao e KPIs, extraido dos workbooks
 * Tableau originais:
 *   - "EE - KPIs Report_v18 (5g New KPIs).twb"        -> Daily
 *   - "EE - KPIs Report_Hourly_V4 (5G new kpis).twb"  -> Hourly
 *
 * Este ficheiro e a resposta simulada do endpoint KPIsOverview/GetMetadata.
 * Quando o backend estiver pronto, o catalogo passa a vir da API e este
 * ficheiro pode ser apagado (juntamente com KPIsOverviewDummyRequests.js).
 *
 * O campo `aggregation` diz ao backend que operacao SQL aplicar:
 *   ratio_of_sums     -> SUM(num) / NULLIF(SUM(den), 0)   <-- nunca AVG
 *   sum               -> SUM(col)
 *   avg               -> AVG(col)
 *   max               -> MAX(col)
 *   sum_of_difference -> SUM(den) - SUM(num)
 * ---------------------------------------------------------------------------
 */

export const GRANULARITIES = [
	{ value: 'daily', text: 'Daily' },
	{ value: 'hourly', text: 'Hourly' }
];

export const TECHNOLOGIES = [
	{ value: '2G', text: '2G' },
	{ value: '4G', text: '4G' },
	{ value: '5G', text: '5G' }
];

export const CATALOGUE = {
	'2G': {
		technology: '2G',
		aggregationLevels: [
			{ value: 'site', text: 'Site', availableDaily: true, availableHourly: true },
			{ value: 'cell', text: 'Cell', availableDaily: true, availableHourly: true },
			{ value: 'sector', text: 'Sector', availableDaily: false, availableHourly: false },
			{ value: 'cluster', text: 'Cluster', availableDaily: true, availableHourly: true },
		],
		kpis: [
			{
				value: 'tch_availability',
				text: 'TCH Availability',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'voice_cssr',
				text: 'Voice CSSR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'voice_cssr_phase1',
				text: 'Voice CSSR Phase1',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'voice_cssr_phase2',
				text: 'Voice CSSR Phase2',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'voice_cssr_phase3',
				text: 'Voice CSSR Phase3',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'voice_dcr',
				text: 'Voice DCR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'ps_cssr',
				text: 'Ps Cssr',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'ps_dcr',
				text: 'Ps Dcr',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'hosr',
				text: 'Hosr',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'cs_traffic_erl',
				text: 'CS Traffic Erl',
				unit: 'Erlang',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'data_volume_dl_mb',
				text: 'Data Volume DL MB',
				unit: 'MB',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'data_volume_ul_mb',
				text: 'Data Volume UL MB',
				unit: 'MB',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'ho_attempts',
				text: 'HO Attempts',
				unit: 'count',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'link_balance',
				text: 'Link Balance',
				unit: 'dB',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'rx_level_dl',
				text: 'Rx level DL',
				unit: 'dBm',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'rx_level_ul',
				text: 'Rx level UL',
				unit: 'dBm',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'ta',
				text: 'TA',
				unit: 'TA units',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'tch_availability_1',
				text: 'TCH Availability 1',
				unit: '%',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'tch_availability_2',
				text: 'TCH Availability 2',
				unit: '%',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'tch_availability_3',
				text: 'TCH Availability 3',
				unit: '%',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'ho_fails',
				text: 'HO Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: false
			},
			{
				value: 'ps_cssr_fails',
				text: 'Ps Cssr Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: false
			},
			{
				value: 'voice_cssr_fails',
				text: 'Voice CSSR Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: false
			},
		]
	},
	'4G': {
		technology: '4G',
		aggregationLevels: [
			{ value: 'site', text: 'Site', availableDaily: true, availableHourly: true },
			{ value: 'cell', text: 'Cell', availableDaily: true, availableHourly: true },
			{ value: 'sector', text: 'Sector', availableDaily: true, availableHourly: true },
			{ value: 'frequency', text: 'Frequency', availableDaily: true, availableHourly: true },
			{ value: 'cluster', text: 'Cluster', availableDaily: true, availableHourly: true },
		],
		kpis: [
			{
				value: 'cell_availability',
				text: 'Cell Availability',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'rrc_accessibility',
				text: 'RRC Accessibility',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 's1_accessibility',
				text: 'S1 Accessibility',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'erab_ssr',
				text: 'Erab Ssr',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_sssr',
				text: 'Lte Sssr',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_retainability',
				text: 'LTE Retainability',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'volte_ssr',
				text: 'VoLTE SSR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'volte_dcr',
				text: 'VoLTE DCR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_srvcc',
				text: 'Lte Srvcc',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'interfreq_ho_sr',
				text: 'Interfreq HO SR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'intrafreq_ho_sr',
				text: 'IntraFreq HO SR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_to_gsm_hosr',
				text: 'LTE to GSM HOSR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_to_umts_hosr',
				text: 'LTE to UMTS HOSR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'packet_loss_data',
				text: 'Packet Loss Data',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'packet_loss_voice',
				text: 'Packet Loss Voice',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_good_voice_quality',
				text: 'LTE Good Voice Quality',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'prb_dl_usage',
				text: 'Prb Dl Usage',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'prb_ul_usage',
				text: 'Prb Ul Usage',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'pdcch_utilization',
				text: 'PDCCH Utilization',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'average_cqi',
				text: 'Average CQI',
				unit: 'index 0-15',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_rssi',
				text: 'Lte Rssi',
				unit: 'dBm',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_ta',
				text: 'Lte Ta',
				unit: 'm / TA units',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'ul_sinr_pucch',
				text: 'UL SINR PUCCH',
				unit: 'dB',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'ul_sinr_pusch',
				text: 'UL SINR PUSCH',
				unit: 'dB',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'user_dl_thput',
				text: 'User DL Thput',
				unit: 'kbps/Mbps',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'user_ul_thput',
				text: 'User UL Thput',
				unit: 'kbps/Mbps',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'average_number_of_volte_users',
				text: 'Average Number of VoLTE Users',
				unit: 'count',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'mimo_rank_1',
				text: 'Mimo Rank 1',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'mimo_rank_2',
				text: 'Mimo Rank 2',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'mimo_rank_3',
				text: 'Mimo Rank 3',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'mimo_rank_4',
				text: 'Mimo Rank 4',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'data_volume_dl_gb',
				text: 'Data Volume DL GB',
				unit: 'GB',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'data_volume_ul_gb',
				text: 'Data Volume UL GB',
				unit: 'GB',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_erab_attempts',
				text: 'LTE ERAB Attempts',
				unit: 'count',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'volte_traffic_erlang',
				text: 'VoLTE Traffic Erlang',
				unit: 'Erlang',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'rrc_conn_users',
				text: 'RRC Conn Users',
				unit: 'count',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'max_rrc_connected_users',
				text: 'Max RRC connected users',
				unit: 'count',
				aggregation: 'max',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'h_rssi_branch_imbalance',
				text: 'H RSSI Branch Imbalance',
				unit: 'dB',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'avg_rtwp_rx_ant_1',
				text: 'Avg Rtwp Rx Ant 1',
				unit: 'dBm',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'avg_rtwp_rx_ant_2',
				text: 'Avg Rtwp Rx Ant 2',
				unit: 'dBm',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'avg_rtwp_rx_ant_3',
				text: 'Avg Rtwp Rx Ant 3',
				unit: 'dBm',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'avg_rtwp_rx_ant_4',
				text: 'Avg Rtwp Rx Ant 4',
				unit: 'dBm',
				aggregation: 'avg',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'lte_sssr_fails',
				text: 'LTE SSSR Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: true
			},
			{
				value: 'erab_ssr_fails',
				text: 'ERAB SSR Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: true
			},
			{
				value: 'rrc_accessibility_fails',
				text: 'RRC Accessibility Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: true
			},
			{
				value: 'volte_ssr_fails',
				text: 'VoLTE SSR Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: true
			},
			{
				value: 'interfreq_ho_fails',
				text: 'Interfreq HO Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: true
			},
			{
				value: 'intrafreq_ho_fails',
				text: 'IntraFreq HO Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: false,
				isMain: true
			},
		]
	},
	'5G': {
		technology: '5G',
		aggregationLevels: [
			{ value: 'site', text: 'Site', availableDaily: true, availableHourly: true },
			{ value: 'cell', text: 'Cell', availableDaily: true, availableHourly: true },
			{ value: 'sector', text: 'Sector', availableDaily: true, availableHourly: true },
			{ value: 'frequency', text: 'Frequency', availableDaily: true, availableHourly: true },
			{ value: 'cluster', text: 'Cluster', availableDaily: true, availableHourly: true },
		],
		kpis: [
			{
				value: 'radio_network_availability_rate',
				text: 'Radio Network availability Rate',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'random_access_success_rate',
				text: 'Random Access Success Rate',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sgnb_setup_success_rate_gnb',
				text: 'SgNB Setup Success Rate (gNB)',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sgnb_setup_success_rate_gnb_modified',
				text: 'SgNB Setup Success Rate (gNB) Modified',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: false,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sgnb_drop_rate',
				text: 'SgNB Drop Rate',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'inter_gnb_pscell_change_sr',
				text: 'Inter gNB PSCell Change SR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'intra_gnb_pscell_change_sr',
				text: 'Intra gNB PSCell Change SR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'total_pscell_change_sr',
				text: 'Total PSCell Change SR',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'user_downlink_average_throughput_ee',
				text: 'User Downlink Average Throughput EE',
				unit: 'Mbps',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'user_uplink_average_throughput_ee',
				text: 'User Uplink Average Throughput EE',
				unit: 'Mbps',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sa_rrc_setup_success_cfn',
				text: 'SA RRC Setup Success (CFN)',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sa_ng_setup_success_cfn',
				text: 'SA NG Setup Success (CFN)',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sa_data_drb_stp_success_cfn',
				text: 'SA Data DRB Setup Success (CFN)',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'cont_free_rach_stp_sr_cfn',
				text: 'Contention-free RACH Setup SR (CFN)',
				unit: '%',
				aggregation: 'ratio_of_sums',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'data_volume_dl',
				text: 'Data Volume DL',
				unit: 'GB',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'data_volume_ul',
				text: 'Data Volume UL',
				unit: 'GB',
				aggregation: 'sum',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'nsa_max_number_users',
				text: 'NSA Max Number Users',
				unit: 'count',
				aggregation: 'avg',
				availableDaily: false,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'nsa_avgumber_conn_users',
				text: 'NSA Avg Number Conn Users',
				unit: 'count',
				aggregation: 'ratio_of_sums',
				availableDaily: false,
				availableHourly: true,
				isMain: false
			},
			{
				value: 'inter_gnb_fails',
				text: 'Inter gNB Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'intra_gnb_fails',
				text: 'Intra gNB Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'random_access_sr_fails',
				text: 'Random Access SR Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'sgnb_setup_sr_fails',
				text: 'SgNB Setup SR Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
			{
				value: 'total_pscell_fails',
				text: 'Total PSCell Fails',
				unit: 'count',
				aggregation: 'sum_of_difference',
				availableDaily: true,
				availableHourly: true,
				isMain: true
			},
		]
	}
};

export const DEFAULT_TECHNOLOGY = '4G';
export const DEFAULT_GRANULARITY = 'daily';
export const DEFAULT_AGGREGATION_LEVEL = 'site';

/* Formata um valor de KPI de acordo com a unidade declarada no catalogo. */
export const FormatKpiValue = (value, unit) => {
	if (value === null || value === undefined) {
		return '-';
	}
	if (unit === '%') {
		return Number(value).toFixed(2) + ' %';
	}
	if (unit === 'dB' || unit === 'ms' || unit === 'Mbps') {
		return Number(value).toFixed(2) + ' ' + unit;
	}
	return Number(value).toFixed(2);
};
